import React, { useEffect, useState } from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {Layout, Menu} from "antd";
import {Content, Footer, Header} from "antd/es/layout/layout";
import CommonHeader from "../components/common-header";
import styled from "styled-components";
import { getSystemInfo } from "../http/home";
import {ReactComponent as homeSvg} from "../svg/home-fill.svg";
import {ReactComponent as formSvg} from "../svg/form-fill.svg";
import {ReactComponent as cameraSvg} from "../svg/camera-fill.svg";
import {ReactComponent as inspectionSvg} from "../svg/inspection-fill.svg";
import {ReactComponent as couponSvg} from "../svg/coupons-fill.svg";
import {ReactComponent as officeSvg} from "../svg/office-supplies-fill.svg";
import {ReactComponent as aboutUsSvg} from "../svg/about-us.svg";
import Icon from "@ant-design/icons";

const MenuItems = [
    {key: "/home/search", label: "首页", icon: <Icon style={{fontSize:"28px"}}  component={homeSvg}/>},
    {key: "/home/classify", label: "蜡叶标本库", icon: <Icon style={{fontSize:"28px"}}  component={formSvg}/>},
    {key: "/home/library", label: "原植物图库", icon: <Icon style={{fontSize:"28px"}}  component={cameraSvg}/>},
    {key: "/home/atlas", label: "图谱库", icon: <Icon style={{fontSize:"28px"}}  component={inspectionSvg}/>},
    {key: "/home/dna", label: "DNA序列库", icon: <Icon style={{fontSize:"28px"}}  component={couponSvg}/>},
    {key: "/home/publicity", label: "科普宣传", icon: <Icon style={{fontSize:"28px"}}  component={officeSvg}/>},
    {key: "/home/about-us", label: "关于我们", icon: <Icon style={{fontSize:"24px"}}  component={aboutUsSvg}/>},
];

const Home: React.FC = () => {

    const navigateTo = useNavigate();
    const location = useLocation();
    let [footerInfo, setFooterInfo] = useState({copyright:'', addr:'', link:'', linktel:'', email:'', state:''});

    useEffect(() => {
      systemInfo({});
      return;
    }, []);

    const systemInfo = (params:any)=> {
      getSystemInfo(params).then((res:any)=> {
        const { copyright, addr, link, linktel, email, state } = res.data[0];
        setFooterInfo({
          copyright: copyright,
          addr: addr,
          link: link,
          linktel: linktel,
          email: email,
          state: state
        })
      }).catch((e) => {
          console.log("error:"+e.message)
      })
    }

    const onclick = (info: any) => {
        const {key, label} = info;
        navigateTo(key);
    }

    return (<Wrapper>
        <Layout>
            <CommonHeader/>
            <Header style={{background: "#1990FF", height:"70px",padding: "0"}}>
                <Menu
                    onClick={onclick}
                    mode={"horizontal"}
                    defaultSelectedKeys={[location.pathname]}
                    items={MenuItems}
                />
            </Header>
            <Content >
                <Outlet/>
            </Content>
            <Footer style={{background:"#1E343A", textAlign:"center",height:"70px",width:"100%"}} className={"homeFooter"}>
                <FooterWrapper>
                <FooterContentSpan>Copyright© { footerInfo.copyright }</FooterContentSpan>
                <FooterContentSpan>地址：{ footerInfo.addr }  联系人：{ footerInfo.link }  邮箱：{ footerInfo.email }</FooterContentSpan>
                <FooterContentSpan></FooterContentSpan>
                </FooterWrapper>
            </Footer>
        </Layout>
    </Wrapper>)
}
export default Home;

const Wrapper = styled.div`
  & {
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .ant-menu {
      background: #1990FF;
      font-size: 22px !important;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      color: #fff;
      line-height: 70px !important;
      display: flex;
      justify-content: center;
    }
    .ant-menu-light.ant-menu-horizontal >.ant-menu-item {
      margin-right: 30px;
      height: 70px; 
      text-align: center;
      padding: 0 32px;
      display: flex;
      border-radius: 0 !important;
    }
    .ant-menu-light.ant-menu-horizontal >.ant-menu-item:last-child {
      margin-right: 0;
    }
    .ant-menu-item-selected {
      color: #1990FF !important;
      background: white !important;
      border-radius: 0 !important;
    }
    .ant-menu-light.ant-menu-horizontal >.ant-menu-item::after {
      border: 0;
      border-radius: 0 !important;   
    }
    .ant-menu-light .ant-menu-item:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected), :where(.css-dev-only-do-not-override-26rdvq).ant-menu-light .ant-menu-submenu-title:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected){
      color: white;
    }
    .ant-layout-content {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    .homeFooter {
      background-color: #1E343A;
      display: flex;
      width: 100%;
      height: 70px;
      text-align: center;
      justify-content: center;
    }
  }
`;
const FooterContentSpan = styled.span`
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  color: #fff;
  line-height: 1.75;
`;
const FooterWrapper = styled.div`
  &{
    display: flex;
    flex-direction: column;
  }
`;